import axiosInstance from './axiosInstance';

export interface FavoriteTopicArea {
  id: number;
  user_id: number;
  topic_area_id: number;
  created_at: string;
  title: string;
  summary: string;
  start_year?: number;
  is_current?: string;
  end_year?: number;
}

export async function addFavorite(topicAreaId: number): Promise<void> {
  await axiosInstance.post('/api/favorites', { topicAreaId });
}

export async function getMyFavorites(): Promise<FavoriteTopicArea[]> {
  const res = await axiosInstance.get('/api/favorites');
  return res.data;
}

export async function removeFavorite(topicAreaId: number): Promise<void> {
  await axiosInstance.delete(`/api/favorites/${topicAreaId}`);
}
